export default __webpack_public_path__ + "static/background-pc-ef3780b6ee612d7d718b4df38536f64c.png";